import React from "react";
import formation_home from "../Pages/image/formation-home.png";
import formation_home_2 from "../Pages/image/formation-home-2.png";

function FormationsSection() {
    return (
        <section className="formations-section py-5">
            <div className="container text-center cards_forma">
                <div className="formation-card text-center p-4">
                    <div className="circle-image mx-auto mb-3">
                        <img
                            src={formation_home} // Remplacez avec le chemin réel de l'image
                            alt="Nos Formations"
                            className="img-fluid"
                        />
                    </div>
                    <h3 className="card-title mb-3">NOS FORMATIONS</h3>
                    <p className="card-text mb-4">
                        Découvrez l’ensemble des formations dispensées par nos équipes.
                    </p>
                    <a href="/formations" className="btn btn-danger">
                        Découvrir
                    </a>
                </div>
                <div className="formation-card text-center p-4">
                    <div className="circle-image mx-auto mb-3">
                        <img
                            src={formation_home_2} // Remplacez avec le chemin réel de l'image
                            alt="Nos Formations"
                            className="img-fluid"
                        />
                    </div>
                    <h3 className="card-title mb-3">NOTRE CALENDRIER</h3>
                    <p className="card-text mb-4">
                    Découvrez les dates de nos prochaines formations.
                    </p>
                    <a href="/calendrier" className="btn btn-danger">
                        Accéder
                    </a>
                </div>
            </div>
        </section>
    );
}

export default FormationsSection;